import { getCards, handleDeleteCard } from "../../api/payment/DefaultPaymentHandler.js";
import { deleteCard, saveCreditCard } from "./../../api/services/userService.js";
import { mapGetters } from "vuex";
export default {
  async mounted(that) { 
    if (that.dbuser && that.dbuser.CustomerID) {
      const response = await getCards(that.dbuser.CustomerID, that.currentStoreDoc.HQCompanyID);
      if (!response.error) {
        response.cards.forEach((card) => {
          that.savedCards.push({
            CardIdentifier: card.id,
            ElidedPan: `XXXXXXXXXXXX${card.card.last4}`,
            CardType: card.card.brand
          });
        });
      }
    }
  },
  filters: {
    cardName: function (value) {
      if (!value) return "";
      let index = value.indexOf("card");
      if (index === -1) {
        return value;
      } else {
        return value.substring(0, index);
      }
    },
  },

  computed: {
    ...mapGetters(["user", "currentStoreDoc"]),
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    closeConfirm() {
      this.showConfirm = false;
    },
    selectCard(val) {
      this.selectedCard = val;
      this.showConfirm = true;
      this.cardError = "";
    },
    addCard() {
      this.loading = true;
      const cardElement = this.$refs.cardInfo.getCardElement();
      const stripe = this.$stripe;
      const userInfo = {
        Email: this.dbuser.Email ? this.dbuser.Email : `${this.dbuser.Mobile}@abacus.co`,
        FirstName: this.dbuser.FirstName ? this.dbuser.FirstName : this.dbuser.Mobile
      };
      saveCreditCard(cardElement, stripe, this.user.id, this.currentStoreDoc.HQCompanyID, this.dbuser.CustomerID, userInfo)
        .then(async res => {
          if (res.data.Success === true) {
            this.savedCards = [];
            await this.getSavedCards();
            this.loading = false;
            this.$refs.addModal.hideModal();
          } else {
            this.error = res.data.Message || res.data.Status.Message;
          }
        })
        .catch(() => {
          this.loading = false;
          this.error = "Network Error ...!";
        });
    },
    async deleteCard() {
      this.deleting = true;
      this.cardError = "";
      deleteCard(
        this.user.id,
        this.selectedCard,
        this.currentStoreDoc.HQCompanyID
      )
        .then(async () => {
          this.deleting = false;
          const resp = await handleDeleteCard(this.selectedCard, this.currentStoreDoc.HQCompanyID);
          if (resp.success) {
            this.savedCards = [];
            await this.getSavedCards();
            this.$refs.deleteConfirm.hideModal();
          } else {
            this.cardError = resp.error;
          }
        })
        .catch(() => {
          this.cardError = "Network Error ...!";
          this.deleting = false;
        });
    },
    fncShowModal() {
      this.showModal = true;
      this.editModel = {};
    },
    async getSavedCards() {
      const response = await getCards(this.dbuser.CustomerID, this.currentStoreDoc.HQCompanyID);
      if (!response.error) {
        response.cards.forEach((card) => {
          this.savedCards.push({
            CardIdentifier: card.id,
            ElidedPan: `XXXXXXXXXXXX${card.card.last4}`,
            CardType: card.card.brand
          });
        });
      }
    },
  },
};
